import { Button, Icon, Menu } from '@percent/lemonade'

export type RowAction = {
  key: string
  label: string
  onClick: () => void
  dataTestId: string
  /** False leaves the action out. */
  isVisible?: boolean
  /** Shows the action disabled, with this as its tooltip. */
  disabledReason?: string
}

type RowActionsMenuProps = {
  /** The trigger's accessible name, e.g. "Actions for Payouts". */
  label: string
  dataTestId: string
  actions: RowAction[]
}

/** A table row's actions behind a kebab trigger; nothing at all when none of them is visible. */
export function RowActionsMenu({ label, dataTestId, actions }: Readonly<RowActionsMenuProps>) {
  const items = actions
    .filter(({ isVisible = true }) => isVisible)
    .map(({ key, label: itemLabel, onClick, dataTestId: itemTestId, disabledReason }) => ({
      key,
      label: itemLabel,
      onClick,
      dataTestId: itemTestId,
      shouldBeDisabled: disabledReason !== undefined,
      disabledTooltipInfo: disabledReason
    }))

  return (
    <Menu
      sections={[{ items }]}
      customTriggerComponent={
        <Button variant="tertiary" size="mini" aria-label={label} data-testid={dataTestId}>
          <Icon name="menu-vertical" size={5} />
        </Button>
      }
    />
  )
}
